export default {
  type: Object.freeze({
    ROOT: 'root', ADMIN: 'admin', OPERATOR: 'operator', SYS_ADMIN: 'sys_admin', SUPPORT: 'support', DOCTOR: 'doctor',
    ONLINE_APPOINTMENT_SERVICE_API: 'online-appointment-service-api', SITE_LEAD_SERVICE_API: 'site-lead-service-api',
    ALL: 'all'
  }),
  category: Object.freeze({
    USUAL: 'usual', SERVICE: 'service', USUAL_LABEL: 'Группы прав', SERVICE_LABEL: 'Сервисные группы прав'
  }),
}
